import React from "react";

const Loader = () => (
  <div className="absolute w-full h-full top-0 left-0 right-0 bottom-0 flex flex-wrap items-center justify-center">
    <div className="kissht-ripple">
      <div></div>
      <div></div>
    </div>
  </div>
);

// keepMounted: keep children at the same tree position while spinning so they
// are not remounted, otherwise uncontrolled inputs (e.g. KisshtAutoCompleteAsync)
// lose their displayed value whenever spinning toggles.
const Spin = ({ children, spinning, keepMounted = false }) => {
  if (keepMounted) {
    return (
      <div className="relative w-full">
        <div style={spinning ? { opacity: 0.5 } : undefined}>{children}</div>
        {spinning && <Loader />}
      </div>
    );
  }

  return (
    <div className="relative w-full">
      {spinning && (
        <>
          <div style={{ opacity: 0.5 }}>{children}</div>
          <Loader />
        </>
      )}
      {!spinning && children}
    </div>
  );
};

export default Spin;
